import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65caf076"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_footer_wrap" }
const _hoisted_2 = { class: "footer_title heavy" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "bottom-row" }
const _hoisted_5 = { class: "lang" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("｜ ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rights" }, [
  /*#__PURE__*/_createTextVNode("         © 2013-2022 huamei2001.com 版权所有。 ICP证："),
  /*#__PURE__*/_createElementVNode("a", { href: "https://beian.miit.gov.cn/#/Integrated/index" }, "粤ICP备11083341号")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PromptSMS = _resolveComponent("PromptSMS")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages.filter(x=>!['主页', '联系\n我们'].includes(x.pageNameCN)), (p) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass({footer_block:true, last:p.data=='about'}),
        key: p.data
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(p.pageNameCN.replace("\n", "")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.tabs, (t) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "footer_title clickable",
            key: t,
            onClick: ($event: any) => (_ctx.goto(p,t))
          }, [
            _createElementVNode("span", null, _toDisplayString(t.replace("\n", "")), 1)
          ], 8, _hoisted_3))
        }), 128))
      ], 2))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "langBtn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changeLang('cnt')), ["stop","prevent"]))
        }, _toDisplayString(_ctx.lang.cn == 's' ? '繁体' : '简体'), 1),
        _hoisted_6,
        _createElementVNode("div", {
          class: "langBtn",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changeLang('eng')), ["stop","prevent"]))
        }, _toDisplayString(_ctx.lang.eng ? '中文' : 'Eng'), 1)
      ]),
      _hoisted_7
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showLogin)
          ? (_openBlock(), _createBlock(_component_PromptSMS, {
              key: 0,
              title: "手机登录",
              prompts: ['手机号','验证码'],
              type: "login",
              onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showLogin=false)),
              onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showLogin=false)),
              onConfirm: _ctx.onConfirmLogin,
              onRegister: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showLogin=false,_ctx.showRegister=true))
            }, null, 8, ["onConfirm"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}